module.exports = __webpack_public_path__ + "static/media/OptInScreen.d23715e8.png";